import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import '../css/OrderTracking.css';

const OrderTracking = () => {
  const { orderId } = useParams();
  const [trackingDetails, setTrackingDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTrackingDetails = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/orders/traceOrder/${orderId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setTrackingDetails(response.data);
      } catch (error) {
        console.error('Failed to fetch tracking details:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTrackingDetails();
  }, [orderId]);

  if (loading) {
    return <div>Loading tracking details...</div>;
  }

  if (!trackingDetails) {
    return <div>No tracking details available for this order.</div>;
  }

  const updates = trackingDetails.updates || []; // Safeguard to ensure updates is always an array

  return (
    <div className="order-tracking-container">
      <h2>Order Tracking for Order ID: {orderId}</h2>
      <div className="tracking-info">
        <p><strong>Status:</strong> {trackingDetails.status || 'N/A'}</p>
        <p><strong>Current Location:</strong> {trackingDetails.currentLocation || 'N/A'}</p>
        <p><strong>Expected Delivery Date:</strong> {trackingDetails.expectedDeliveryDate || 'N/A'}</p>
        <h3>Tracking Updates:</h3>
        {updates.length > 0 ? (
          <ul className="tracking-updates">
            {updates.map((update, index) => (
              <li key={index}>
                <p><strong>Date:</strong> {new Date(update.localDateTime).toLocaleString()}</p>
                <p><strong>Details:</strong> {update.updates}</p>
              </li>
            ))}
          </ul>
        ) : (
          <p>No updates available.</p>
        )}
      </div>
    </div>
  );
};

export default OrderTracking;
